/**
 * @generated SignedSource<<507c9af99c48ae3c9ad7e864321b5138>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingBannerRefetchQuery$variables = {
  id: string;
};
export type MemberOnboardingBannerRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingBannerRefetchableFragment_usage">;
  } | null;
};
export type MemberOnboardingBannerRefetchQuery = {
  response: MemberOnboardingBannerRefetchQuery$data;
  variables: MemberOnboardingBannerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MemberOnboardingBannerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MemberOnboardingBannerRefetchableFragment_usage"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MemberOnboardingBannerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerHasCompleted",
                "storageKey": null
              }
            ],
            "type": "ContentUsage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76acc57849a729febc68a2e4cb7bca26",
    "id": null,
    "metadata": {},
    "name": "MemberOnboardingBannerRefetchQuery",
    "operationKind": "query",
    "text": "query MemberOnboardingBannerRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...MemberOnboardingBannerRefetchableFragment_usage\n    id\n  }\n}\n\nfragment MemberOnboardingBannerRefetchableFragment_usage on ContentUsage {\n  id\n  viewerHasCompleted\n}\n"
  }
};
})();

(node as any).hash = "41cb3bc8cd64eaf817b62c2db4775deb";

export default node;
